import React, { useContext } from "react";
import { Icons } from "../Icons";
import { DropdownContext } from "./Dropdown";

/**
 * Trigger size → CSS class mapping.
 * Controls padding and font-size of the trigger element.
 */
var TRIGGER_SIZES = {
    Small: "small",
    Default: "default",
};

/**
 * DropdownTrigger — The visible element that the user interacts with to open/close the dropdown.
 *
 * Renders children (your custom trigger content) with an optional chevron icon
 * on either side. The icon position and visibility are configurable.
 *
 * @param {string}  Size           - 'Small' | 'Default'
 * @param {boolean} IsIconVisible  - Show the dropdown indicator icon
 * @param {string}  IconPosition   - 'left' | 'right' — which side the icon appears
 * @param {string}  IconName       - Icon name (default: chevron-down)
 */
export const DropdownTrigger = ({ children, Size = "Default", IsIconVisible = true, IconPosition = "right", IconName = "chevron-down", ShowHover = true, fontClass = "body-m", customClasses = "", customStyle = {}, iconClassName = "" }) => {
    const { open, handleToggle } = useContext(DropdownContext) || { open: false };

    // Automatically flip chevron-down to chevron-up when the dropdown is open
    const finalIconName = (IconName === "chevron-down" && open) ? "chevron-up" : IconName;

    return (
        <div className={`dropdown-trigger dropdown-trigger-${TRIGGER_SIZES[Size]} ${fontClass} ${!ShowHover ? 'dropdown-trigger--no-hover' : ''} ${customClasses}`} style={customStyle} onClick={(e) => { e.stopPropagation(); handleToggle?.(); }}>
            {IsIconVisible && IconPosition === "left" && <Icons name={finalIconName} className={`dropdown-trigger-icon mr-s ${iconClassName}`} />}
            
            <span className="dropdown-trigger-text">
                {children}
            </span>

            {IsIconVisible && IconPosition === "right" && <Icons name={finalIconName} className={`dropdown-trigger-icon ml-s ${iconClassName}`} />}
        </div>
    );
};